import { Button } from "#/components/ui/button";

interface UndoButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export function UndoButton({ onClick, disabled }: UndoButtonProps) {
  return (
    <Button type="button" variant="accent" size="lg" onClick={onClick} disabled={disabled}>
      Undo
    </Button>
  );
}
